export function replaceUrlParams(
    url: string,
    params: {
        [key: string]: string | number;
    }
): string {
    return Object.keys(params).reduce((acc, key) => {
        const paramValue = params[key].toString();
        return acc.replace(`:${key}`, paramValue);
    }, url);
}
